// @flow
import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {usePrefs} from 'docs/data';
import type {
  PlatformsForReader,
  PlatformsForCountry,
  ClientsForPlatform,
} from 'docs/data/integration-builder';
import {Setting} from './Setting';

const messages = defineMessages({
  platform: {
    id: 'docsApp.integrationBuilder.settings.platform',
    description: 'Platform label',
    defaultMessage: 'Platform:',
  },
});

type PlatformsForReaderSettingProps = {|
  platformsForReader: PlatformsForReader,
  platformsForCountry: PlatformsForCountry,
  clients: ClientsForPlatform,
|};

export const PlatformsForReaderSetting = ({
  platformsForReader,
  platformsForCountry,
  clients,
}: PlatformsForReaderSettingProps) => {
  const {getPref, setPrefs} = usePrefs();
  const readers = Object.keys(platformsForReader);
  const countryPref = getPref('integration-country');
  const readerPref = getPref('reader');
  const platformPref = getPref('platform');
  let platform;
  let platforms;

  if (readerPref && readers.includes(readerPref)) {
    // The user has a valid reader set as a pref
    // select a platform to default to based on the platform pref
    platforms = platformsForReader[readerPref];
    if (countryPref) {
      platforms = platforms.filter((p) =>
        platformsForCountry[countryPref].includes(p),
      );
    }

    if (platformPref && platforms.includes(platformPref)) {
      platform = platformPref;
    } else {
      platform = platforms[0];
      setPrefs({platform});
    }
  } else {
    // No valid reader set as a pref, default to the first reader option
    platforms = platformsForReader[readers[0]];
    platform = platforms[0];
    setPrefs({reader: readers[0], platform});
  }

  return (
    <Setting
      label={<FormattedMessage {...messages.platform} />}
      pref="platform"
      activeItem={platform}
      items={platforms}
      getExtraPrefs={(selectedPlatform) => {
        const newPlatform =
          platforms.find((p) => p === selectedPlatform) || platforms[0];
        const client = clients[newPlatform][0];

        return {client};
      }}
    />
  );
};
